import { render, staticRenderFns } from "./basicInfoType.vue?vue&type=template&id=10dbe14f&scoped=true&"
import script from "./basicInfoType.vue?vue&type=script&lang=js&"
export * from "./basicInfoType.vue?vue&type=script&lang=js&"
import style0 from "./basicInfoType.vue?vue&type=style&index=0&id=10dbe14f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dbe14f",
  null
  
)

export default component.exports